import { render } from "./ChatHelper.vue?vue&type=template&id=52f9a5a0&scoped=true"
import script from "./_ChatHelper.js?vue&type=script&lang=js"
export * from "./_ChatHelper.js?vue&type=script&lang=js"

import "./_ChatHelper.less?vue&type=style&index=0&id=52f9a5a0&lang=less&scoped=true"

import exportComponent from "/home/aichat/aichat-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f9a5a0"]])

export default __exports__